import { LitElement, html, css } from 'lit';
import {msg,str} from '@lit/localize';
import { validateForm } from '../../utilities/formsUtilities';
import { accessibility,formStyles} from '../../utilities/styles';


export class AllInEmailConfirmation extends LitElement {
    static properties = {
        _confirmation: {type: String, state: true},
        resturl: {type: String},
        nonce: {type: String},
        config_hardlinks: { type: Object, reflect: true },
        supportEmail: { type: String },
        verifyEmailLink : { type: String},
    }

    constructor() {
        super();
        this.supportEmail = 'https://allin.zendesk.com/hc/en-gb/articles/4945686282143-Contact-us';
        this.verifyEmailLink = '/verify-your-email/'
    }

    createRenderRoot() { 
        return this;
    }
    
    connectedCallback() {
        super.connectedCallback();
        let queryString = window.location.search;
        let params = new URLSearchParams(queryString);
        this.token = params.get('token_hash');
        if(this.token){
            this.message = html`
                <h3>${msg('Email Confirmation')}</h3>
                <button @click="${this.handleVerification}" class="button decorative">${msg('Complete your verification')}</button>
                <p class="resend-verify-email">${msg(`Email confirmation link has expired?`,{desc:'Part of a paragraph describing steps to take if the user didn\'t receive a verification email'})} <a href="${this.verifyEmailLink}" target="_blank">${msg(`Resend your verification email`,{desc:'Part of a paragraph describing steps to take if the user didn\'t receive a verification email'})}</a> ${msg(`or`,{desc:'Part of a paragraph describing steps to take if the user didn\'t receive a verification email'})} <a href="${this.supportEmail}">${msg(`contact us`,{desc:'Part of a paragraph describing steps to take if the user didn\'t receive a verification email'})}</a>.</p>
            `
        }
        else{
            let confirmation_message = window.location.hash;
            if(confirmation_message && confirmation_message.includes('otp_expired')){
                this.message=msg(html`<p>The link you followed has expired.</p>
                    <p>If you weren't expecting this link to be expired, please contact your IT department to check if this domain (https://allin.online) is in the allowlist.</p>
                    <p><a href="${this.config_hardlinks.verify_your_email}">Please request a new one</a></p>`);
                this.header = msg('Link Expired');
                let header = document.querySelector('h1');
                if(header){
                    header.innerHTML = this.header;
                }
            }
            else{
                this.message = msg(html`<p>Your email has been verified</p><p><a href="${this.config_hardlinks.login}">Login to your account</a></p>`);
            }
        }
    }

    render() {
        if(this._confirmation) {
            return html`
                <div class="">
                    <div class="bg">
                        <h3>${msg('Email Confirmation')}</h3>
                        <p>${this._confirmation}</p>
                    </div>
                </div>
            `;
        }
        return html` 
            <div class="">
                <div class="bg">
                    ${this.message}
                </div>
            </div>
        `
    }

    handleVerification() {
        if(this.token){
            fetch(this.resturl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Verify': 'verify',
                },
                body: JSON.stringify({token_hash: this.token}),
            })
            .then(response => response.json())
            .then(data => {
                if(data.ok){
                    this._confirmation = data.message;
                    window.location.href = data.redirect;
                }
                else{
                    this._confirmation = html`${msg('There was an error verifying your email.')} <a href="${this.config_hardlinks.verify_your_email}">${msg('Request a new email verification.')}</a>`;
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        }
    }

}